import { render, staticRenderFns } from "./CommentWidget.vue?vue&type=template&id=30b2fc8a&"
import script from "./CommentWidget.vue?vue&type=script&lang=ts&"
export * from "./CommentWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports